import { Link } from "react-router-dom";
import { ArrowUpRight, Clock } from "lucide-react";

export const fmtDate = (d) => (d ? new Date(d).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : "");

export function PostCard({ post, featured = false }) {
  return (
    <Link to={`/blog/${post.slug}`} data-testid={`post-card-${post.slug}`} className={`card group flex flex-col !p-0 overflow-hidden ${featured ? "md:col-span-2 md:flex-row" : ""}`}>
      <div className={`relative overflow-hidden bg-[var(--surface)] ${featured ? "md:w-1/2" : "aspect-[16/10]"}`}>
        {post.cover_image ? (
          <img src={post.cover_image} alt={post.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.03]" />
        ) : (
          <div className="grid-lines flex h-full min-h-[180px] w-full items-end bg-[var(--navy)] p-6"><span className="font-mono text-xs uppercase tracking-widest text-teal-300">MarksMan Insights</span></div>
        )}
      </div>
      <div className="flex flex-1 flex-col p-6">
        <div className="flex flex-wrap items-center gap-2 text-[11px] font-mono uppercase tracking-wider text-slate-500">
          <span>{fmtDate(post.published_at)}</span>
          {post.reading_minutes && <span className="inline-flex items-center gap-1"><Clock size={11} /> {post.reading_minutes} min</span>}
        </div>
        <h3 className={`mt-3 font-semibold leading-snug text-[var(--navy)] transition-colors duration-200 group-hover:text-[var(--teal)] ${featured ? "text-2xl" : "text-lg"}`}>{post.title}</h3>
        <p className="mt-3 line-clamp-3 text-sm leading-relaxed text-slate-600">{post.excerpt}</p>
        <div className="mt-auto flex flex-wrap items-center justify-between gap-2 pt-5">
          <div className="flex flex-wrap gap-1.5">{(post.categories || []).slice(0, 2).map((c) => <span key={c} className="rounded-full bg-[var(--surface)] px-2.5 py-0.5 text-[11px] font-medium text-slate-600">{c}</span>)}</div>
          <span className="inline-flex items-center gap-1 text-sm font-semibold text-[var(--teal)]">Read <ArrowUpRight size={15} className="transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" /></span>
        </div>
      </div>
    </Link>
  );
}
